import { ursaColors } from "@smartsheet/design-tokens";
import React, { forwardRef, Ref } from "react";
import { GeneratedIconProps } from "../../icon/GeneratedIconProps";
import { Icon } from "../../icon/Icon";
import ProgressCircleIconSvg from "./ProgressCircleSvg";

export interface ProgressCircleIconProps extends GeneratedIconProps {
    /**
     * The size to render the icon at.
     */
    size: 20;
    /** Automatically set the direction and color based on value. */
    value: 0 | 25 | 50 | 75 | 100;
    /** The `color` prop will handle the main (blue) fill, but if you need to change the white unfilled color, use this prop. */
    emptyFillColor?: string;
}

export const ProgressCircleIcon = forwardRef(
    (
        { color = ursaColors.azure400, size, value, emptyFillColor, ...rest }: ProgressCircleIconProps,
        ref: Ref<HTMLElement>
    ) => (
        <Icon color={color} ref={ref} size={size} {...rest}>
            <ProgressCircleIconSvg value={value} emptyFillColor={emptyFillColor} />
        </Icon>
    )
);

ProgressCircleIcon.displayName = "ProgressCircleIcon";
